import React, { useState } from "react";
import axios from "axios";
import { Box, Typography, TextField, Button, Alert, Stack } from "@mui/material";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");
        try {
            await axios.post(`${API_BASE_URL}/users/forgot-password`, { email });
            setMessage("If the email exists, you will receive a password reset link.");
        } catch (err) {
            setError("Error sending password reset email.");
        }
    };

    return (
        <Box
            maxWidth={400}
            mx="auto"
            mt={8}
            p={4}
            boxShadow={3}
            borderRadius={2}
            bgcolor="background.paper"
        >
            <Typography variant="h5" component="h2" mb={3} textAlign="center">
                Forgot Password
            </Typography>

            {message && (
                <Alert severity="success" sx={{ mb: 2 }}>
                    {message}
                </Alert>
            )}
            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}

            <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <TextField
                        label="Email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        fullWidth
                        autoFocus
                    />
                    <Button variant="contained" type="submit" fullWidth>
                        Send Reset Link
                    </Button>
                </Stack>
            </form>
        </Box>
    );
};

export default ForgotPassword;
